<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h3">{{title}}</div>
          <div class="setting-addel mr-l15">
            <el-button @click="onSavedQueryPopupButton"><i class="fas fa-plus"></i></el-button>
            <el-button :disabled="!selectRowFlag" @click="onDeleteSavedQuery"><i class="fas fa-minus"></i></el-button>
          </div>
        </div>
      <div>
        <w-header-search-button @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :column-default="columnDefault" @condition-change="onChangeTable" :total="total" remote ref="queryTable" row-class-name="c-dblclick"
      highlight-current-row @row-dblclick="onDblClickRow" :data="tableData" :columns="tableColumn" :pagination="true" :show-search-tool="showSearchTool"
      style="width:100%;" header-align="center" :show-custom-header="true" @current-change="onChangeTableRow">
      <template slot-scope="scope" slot="alias-name">
      </template>
    </el-table-wrapper>
    <w-saved-query-sliding-popup @load-data="loadData" ref="savedQuerySlidingPopup" :title="title"></w-saved-query-sliding-popup>
  </div>
</template>

<script>
import { columnDefault } from '@/constants/table';
import DbmsSavedQueryApi from '@/api/settings/common/dbms-saved-query';
import { isNil, cloneDeep, forEach } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import WSavedQuerySlidingPopup from '../popup/SavedQuerySlidingPopup';

export default {
  name: 'WSavedQueryCommonTable',
  components: {
    WSavedQuerySlidingPopup,
  },
  props: {
    targetData: {
      type: Object,
      default: () => ({
        rsctypeId: 'OR_USER_QUERY',
        managetypeId: 'DBMS',
      }),
    },
    title: {
      type: String,
    },
  },
  watch: {
    targetData: {
      // immediate: true,
      handler() {
        this.$nextTick(() => {
          this.loadData();
        });
      },
    },
  },
  data() {
    return {
      columnDefault,
      targetRowData: {},
      selectRowFlag: false,
      showSearchTool: false,
      tableData: [],
      total: null,
      tableColumn: [
        {
          prop: 'rscId',
          label: '쿼리 아이디',
          searchable: true,
          sortable: true,
          remoteProp: 'rsc_id',
        },
        {
          prop: 'rscName',
          label: '쿼리 이름',
          formatter: this.getEmptyText,
          searchable: true,
          sortable: true,
          remoteProp: 'rsc_name',
        },
        {
          prop: 'queryContents',
          label: '쿼리 수행문',
          width: 700,
          searchable: true,
          sortable: true,
          remoteProp: 'query_contents',
        },
        {
          prop: 'orderbyIndex',
          label: '정렬순서',
          sortable: true,
        },
      ],
    };
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.queryTable.getParameter();
      const params = {
        rsctypeId: this.targetData.rsctypeId,
        managetype_id: this.targetData.managetype_id,
        ...tableParams,
      };

      DbmsSavedQueryApi.getDbmsQueryinfoList(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        }
      });
    },
    onChangeTable() {
      this.loadData();
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    getEmptyText(row, column, value) {
      if (!isNil(value) && value !== '') {
        return value;
      }
      return EMPTY_TEXT;
    },
    // row 클릭시 해당 row 저장
    onChangeTableRow(row) {
      if (row) {
        this.selectRowFlag = true;
        this.targetRowData = cloneDeep(row);
      } else {
        this.selectRowFlag = false;
      }
    },
    // 테이블 선택 row 삭제
    onDeleteSavedQuery() {
      this.$confirm(...msgUtil.getCustomConfirmData('선택한 대상들을 삭제하시겠습니까?'))
        .then(() => {
          DbmsSavedQueryApi.deleteDbmsQueryInfo(this.targetRowData).then((response) => {
            if (response.data.success) {
              this.loadData();
              this.$message(msgUtil.getCustomResultMsgData('삭제가 완료되었습니다.', true));
            }
          });
        })
        .catch(() => {});
    },
    // 저장 쿼리 추가 팝업창을 띄우며 현재 테이블 데이터 중 가장 큰 정렬 순서의 다음 값으로 기본 세팅을 시킨다.
    onSavedQueryPopupButton() {
      let maxOrderbyIndex = 0;
      forEach(this.tableData, (item) => {
        if (!isNil(item.orderbyIndex) && item.orderbyIndex > maxOrderbyIndex) {
          maxOrderbyIndex = item.orderbyIndex;
        }
      });
      const payload = {
        orderbyIndex: maxOrderbyIndex += 1,
        rsctypeId: this.targetData.rsctypeId,
      };
      this.$refs.savedQuerySlidingPopup.open(payload);
    },
    // row 더블클릭 이벤트 - 등록 마법사를 실행시켜 수정을 수행한다.
    onDblClickRow(row) {
      this.$nextTick(() => {
        this.$refs.savedQuerySlidingPopup.open(row, 'update');
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/database/SavedQuery/components/SavedQueryCommonTable.vue